// @ts-nocheck
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Container } from "./styles";

// Enquanto a lista não chega (ou se a API falhar), mostra isto no lugar da
// lista: sem ele o cliente via "0 pedidos" e achava que o pedido tinha sumido.
export default function AvisoCarregamento({ erro, textoCarregando, textoErro, tentarDeNovo }) {
  return (
    <Container role="status" aria-live="polite">
      {erro ? (
        <>
          <p>{textoErro}</p>
          {tentarDeNovo && (
            <button type="button" onClick={tentarDeNovo}>
              Tentar de novo
            </button>
          )}
        </>
      ) : (
        <>
          <CircularProgress size={32} style={{ color: "var(--principal-50)" }} />
          <p>{textoCarregando}</p>
        </>
      )}
    </Container>
  );
}
